import ITTObjectModel from '../../generated/types/model/resource/ITTObjectModel';

export default class ITTObjectViewModel extends ITTObjectModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
